var map = {
	"./ballroom.jpeg": "174a",
	"./billiard-room.jpeg": "5aa1",
	"./candlestick.jpeg": "334b",
	"./conservatory.jpeg": "b7c8",
	"./dagger.jpeg": "68fb",
	"./dining-room.jpeg": "dd65",
	"./green.jpeg": "d930",
	"./hall.jpeg": "fd3f",
	"./kitchen.jpeg": "1972",
	"./library.jpeg": "288a",
	"./lounge.jpeg": "1d3b",
	"./mustard.jpeg": "3d58",
	"./orchid.jpeg": "31a5",
	"./peacock.jpeg": "ae9e",
	"./pipe.jpeg": "218b",
	"./plum.jpeg": "0b91",
	"./revolver.jpeg": "6d78",
	"./rope.jpeg": "6151",
	"./scarlett.jpeg": "7245",
	"./study.jpeg": "582b",
	"./wrench.jpeg": "8780"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6e02";